import ACSearchQuery from "./ac-search-query";
import PlacementFactory from "./placement";
import Rule from "./rule";
import { TemplateGroup, TemplateRule } from "./ac-templates";
import { getCustomOperators } from './operators';
import { acSelect2FormatState } from "../helpers/strings";
var jQuery = require("jquery");
var ACQueryBuilder = /** @class */ (function () {
    function ACQueryBuilder(element, localize_script, filter_types) {
        this.$el = jQuery(element);
        this.$form = jQuery(AC.table_id).parents('form:first');
        this.filtertypes = filter_types;
        this.query = new ACSearchQuery(localize_script, this.filtertypes);
        this.initialState = '';
        this.setDefaults();
    }
    ACQueryBuilder.prototype.setDefaults = function () {
        this.defaults = {
            operators: {
                nullable: ['is_null', 'is_not_null', 'is_empty', 'is_not_empty', 'date_future', 'date_past', 'date_today']
            }
        };
    };
    ACQueryBuilder.prototype.init = function () {
        var self = this;
        // Start init
        self.query.init();
        if (self.query.hasFilters()) {
            try {
                self.buildQueryBuilder(self.query.getFilters(), self.query.getRules());
            }
            catch (e) {
                this.$el.html('');
                self.buildQueryBuilder(self.query.getFilters(), []);
            }
            self.initEvents();
        }
        new PlacementFactory(AC.meta_type, AdminColumns.ResetFilters, AdminColumns.ActiveFilters).create().place();
    };
    ACQueryBuilder.prototype.buildQueryBuilder = function (filters, rules) {
        if (rules === void 0) { rules = []; }
        this.$el.queryBuilder({
            operators: getCustomOperators(),
            allow_empty: true,
            filters: filters,
            conditions: ['AND'],
            allow_groups: false,
            select_placeholder: ac_search.i18n.select,
            inputs_separator: '<span class="ac-s__separator">-</span>',
            templates: {
                rule: TemplateRule,
                group: TemplateGroup
            },
            rules: rules
        });
    };
    ACQueryBuilder.prototype.initEvents = function () {
        var self = this;
        self.initialState = JSON.stringify(this.getRules());
        /**
         * Init all Rules for the first time
         */
        this.$el.find('.rule-container').each(function () {
            var $rule = jQuery(this);
            var rule = new Rule($rule, self.query);
            self.bindRuleFilterType(rule);
            self.bindRuleOperator(rule);
            self.bindRuleValue(rule);
            rule.$el.addClass('initial');
            rule.compact();
        });
        if (this.$el.find('.rule-container').length === 0) {
            this.$el.find('.rules-group-body').hide();
        }
        // Triggers after the rule is populated with form elements
        this.$el.on('afterApplyRuleFlags.queryBuilder', function (e, rule) {
            var element = rule.$el;
            new Rule(element).compact();
        });
        this.$el.on('click', '[data-add]', function () {
            self.$el.addClass('init');
            self.$el.find('.rules-group-body').css('display', 'inline-block');
        });
        this.$el.on('beforeAddRule.queryBuilder', function (e) {
            if (!self.$el.hasClass('init')) {
                return;
            }
            if (self.validateForm()) {
                self.compactRules();
            }
            if (self.hasOpenRules()) {
                e.preventDefault();
            }
        });
        this.$el.on('click', '.rule-container [data-confirm]', function () {
            if (!self.validateForm()) {
                return;
            }
            jQuery(this).trigger('confirmRule.acQueryBuilder', [new Rule(jQuery(this).closest('.rule-container'))]);
        });
        this.$el.on('confirmRule.acQueryBuilder', '.rule-container', function (e, rule) {
            rule.compact();
            self.checkChangeState();
        });
        this.$el.on('afterDeleteRule.queryBuilder', function () {
            self.checkChangeState();
        });
        this.$el.on('click', '.rule-container.compact', function () {
            new Rule(jQuery(this)).open();
        });
        this.$form.on('submit', function () {
            if (!self.$el.queryBuilder('validate')) {
                self.$form.trigger('ACSearch.validationFailed');
                return false;
            }
            var rules = self.getRules();
            self.disableFields();
            if (rules.rules.length === 0) {
                return;
            }
            var textarea = jQuery('<textarea name="ac-rules">');
            textarea.val(JSON.stringify(rules)).hide();
            self.$el.append(textarea);
            self._sanitizeFieldNames();
        });
        this.$el.on('afterCreateRuleFilters.queryBuilder', function (e, $rule) {
            self.bindRuleFilterType(new Rule($rule.$el, self.query));
        });
        this.$el.on('afterCreateRuleOperators.queryBuilder', function (e, $rule) {
            var rule = new Rule($rule.$el, self.query);
            self.bindRuleOperator(rule);
        });
        this.$el.on('afterCreateRuleInput.queryBuilder', function (e, $rule) {
            var rule = new Rule($rule.$el, self.query);
            self.bindRuleValue(rule);
        });
    };
    ACQueryBuilder.prototype.bindRuleFilterType = function (rule) {
        var self = this;
        var $select = rule.$el.find('.rule-filter-container select');
        rule.$el.find('.rule-operator-container').hide();
        rule.$el.find('.rule-value-container').hide();
        $select.find('option').each(function () {
            var $option = jQuery(this);
            var filter = self.query.getFilter($option.val());
            if (filter) {
                $option.data('label', filter.label);
            }
        });
        $select.find('option:first').val('').text('');
        $select.select2({
            width: 200,
            theme: 'acs2',
            minimumResultsForSearch: 10,
            placeholder: ac_search.i18n.select,
            templateResult: acSelect2FormatState,
            templateSelection: acSelect2FormatState,
            escapeMarkup: function (markup) {
                if (typeof markup === 'object') {
                    return markup.html();
                }
                return markup;
            },
        });
        // Select option if there is only one filter available
        if (!$select.val() && $select.find('option').length === 2) {
            var value = $select.find('option:last').val();
            $select.val(value).trigger('change').next('.select2').addClass('single-value');
        }
    };
    ACQueryBuilder.prototype.bindRuleOperator = function (rule) {
        var filter = rule.getFilter();
        var $operator_container = rule.$el.find('.rule-operator-container');
        $operator_container.show();
        rule.$el.find('.rule-operator-container select option').each(function () {
            var $option = jQuery(this);
            $option.text(filter.operator_labels[$option.val()]);
        });
        this.filtertypes.getTypes().forEach(function (type) {
            type.transformRuleOperator(rule);
        });
        var $select = rule.$el.find('.rule-operator-container select');
        $select.select2({ minimumResultsForSearch: -1, width: 150, theme: 'acs2' });
        if ($select.find('option').length === 1) {
            rule.$el.find('.rule-operator-container').addClass('single-value');
            $select.prop('disabled', true).select2('destroy');
            $operator_container.append("<span class=\"single-value__label\">" + $select.find('option:selected').text() + "</span>");
        }
    };
    ACQueryBuilder.prototype.bindRuleValue = function (rule) {
        var $container = rule.$el.find('.rule-value-container');
        if ($container.find('.form-control').length > 1) {
            $container.addClass('range');
            $container.find('.form-control:first').addClass('first');
            $container.find('.form-control:last').addClass('last');
        }
        this.filtertypes.getTypes().forEach(function (type) {
            type.renderInput(rule);
        });
    };
    /**
     * Changes the input field names so it can be used on the backend
     */
    ACQueryBuilder.prototype._sanitizeFieldNames = function () {
        this.$el.find('li.rule-container').each(function () {
            var $rule = jQuery(this);
            $rule.find('select[name], input[name]').each(function () {
                var $input = jQuery(this);
                var name = $input.attr('name');
                name = name.replace('rule_', 'r');
                name = name.replace(/_/g, '-');
                $input.attr('name', name);
            });
        });
    };
    ACQueryBuilder.prototype.disableFields = function () {
        return this.$el.find('input, select').prop('disabled', true);
    };
    ACQueryBuilder.prototype.enableFields = function () {
        return this.$el.find('input, select').prop('disabled', false);
    };
    ACQueryBuilder.prototype.getRules = function () {
        var rules = this.$el.queryBuilder('getRules');
        var rule_container = this.$el.find('.rule-container');
        if (!rules) {
            return;
        }
        for (var i = 0; i < rules.rules.length; i++) {
            var $rule = jQuery(rule_container[i]);
            if ($rule.data('formatted_value')) {
                rules.rules[i].formatted_value = $rule.data('formatted_value');
            }
        }
        return rules;
    };
    ACQueryBuilder.prototype.compactRules = function () {
        this.$el.find('.rule-container').each(function () {
            new Rule(jQuery(this)).compact();
        });
    };
    ACQueryBuilder.prototype.addRule = function () {
        jQuery('.ac-button__add-filter').trigger('click');
    };
    /**
     * Checks is there are any rules that are closed
     */
    ACQueryBuilder.prototype.hasOpenRules = function () {
        return (this.$el.find('.rule-container:not(.compact)').length);
    };
    /**
     * @returns bool
     */
    ACQueryBuilder.prototype.validateForm = function () {
        return this.$el.queryBuilder('validate');
    };
    ACQueryBuilder.prototype.checkChangeState = function () {
        var newState = JSON.stringify(this.getRules());
        var $button = jQuery('.ac-search-button');
        if (newState === this.initialState) {
            $button.removeClass('button-primary');
        }
        else {
            $button.addClass('button-primary');
        }
        document.dispatchEvent(new CustomEvent('AC_Search_State_Change'));
    };
    return ACQueryBuilder;
}());
export default ACQueryBuilder;
